import Provider from "../Provider";
import MasterDataContextType from "./master_data_context_type";

export default interface MasterDataProvider extends Provider<MasterDataContextType> {
}

export const MasterDataProviderName = "MasterDataProvider";